// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Int from "rescript/lib/es6/belt_Int.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as DomEl$GameDataCore from "../DomEl.res.mjs";
import * as SidebarPadSyncHook$GameDataCore from "./SidebarPadSyncHook.res.mjs";

var appShellNarrowMaxPx = 1479;

var widthStorageKey = "gdc.gamesListWidth";

var collapsedStorageKey = "gdc.gamesListCollapsed";

var gameHubPanelHiddenKey = "gdc.gameHubPanelHidden";

function isResizing(panel) {
  var value = panel._gdcIsResizing;
  if (value !== undefined) {
    return value;
  } else {
    return false;
  }
}

function isGameHubPath(pathname) {
  if (pathname === "/games") {
    return true;
  } else {
    return pathname.startsWith("/games/");
  }
}

function lhspWorkspaceKeyFromPath(pathname) {
  var parts = Belt_Array.keep(pathname.split("/"), (function (part) {
          return part !== "";
        }));
  var key = Belt_Array.get(parts, 0);
  if (key !== undefined) {
    return key;
  } else {
    return "";
  }
}

function workspaceLhspActionForPathChange(previousPathname, nextPathname) {
  var prevKey = lhspWorkspaceKeyFromPath(previousPathname);
  var nextKey = lhspWorkspaceKeyFromPath(nextPathname);
  var action = prevKey === "" || nextKey === "" || prevKey === nextKey ? "Noop" : (
      nextKey === "games" ? "ExpandGameHub" : "Collapse"
    );
  switch (action) {
    case "Noop" :
        return "noop";
    case "Collapse" :
        return "collapse";
    case "ExpandGameHub" :
        return "expand-game-hub";
    
  }
}

function clampGamesListWidth(w) {
  return Math.max(220, Math.min(600, w));
}

function isNearGamesListResizeEdge(clientX, rectRight, resizeZonePxOpt) {
  var resizeZonePx = resizeZonePxOpt !== undefined ? resizeZonePxOpt : 8;
  if (clientX >= rectRight - resizeZonePx) {
    return clientX <= rectRight + 2;
  } else {
    return false;
  }
}

function isNarrowViewport() {
  return matchMedia("(max-width: " + String(appShellNarrowMaxPx) + "px)").matches;
}

function getSavedWidth() {
  var raw = sessionStorage.getItem(widthStorageKey);
  if (raw == null) {
    return 320;
  }
  var n = Belt_Int.fromString(raw);
  if (n !== undefined && n >= 220 && n <= 600) {
    return n;
  } else {
    return 320;
  }
}

function setSavedWidth(w) {
  sessionStorage.setItem(widthStorageKey, String(w));
}

function getSavedCollapsed() {
  var match = sessionStorage.getItem(collapsedStorageKey);
  if ((match == null) || match !== "1") {
    return false;
  } else {
    return true;
  }
}

function setSavedCollapsed(collapsed) {
  sessionStorage.setItem(collapsedStorageKey, collapsed ? "1" : "0");
}

function getGameHubPanelHidden() {
  var match = sessionStorage.getItem(gameHubPanelHiddenKey);
  if ((match == null) || match !== "1") {
    return false;
  } else {
    return true;
  }
}

function setGameHubPanelHidden(hidden) {
  sessionStorage.setItem(gameHubPanelHiddenKey, hidden ? "1" : "0");
}

function fixedExpandedDesktop(panel) {
  return DomEl$GameDataCore.data(panel, "games-list-fixed-expanded-desktop") === "true";
}

function shouldForceExpandedDesktop(panel) {
  if (fixedExpandedDesktop(panel)) {
    return !isNarrowViewport();
  } else {
    return false;
  }
}

function lhspDesktopExpandedContentOpen(panel) {
  var match = panel.querySelector("[data-gdc-lhsp-filters-active]");
  return !(match == null);
}

function setPanelWidth(panel, w) {
  var px = String(w) + "px";
  panel.style.width = px;
  panel.style.minWidth = px;
  SidebarPadSyncHook$GameDataCore.syncAppSidebarPad();
}

function applyCollapsedState(panel, collapsed) {
  if (collapsed) {
    DomEl$GameDataCore.addClass(panel, "collapsed");
    return setPanelWidth(panel, 48);
  } else {
    DomEl$GameDataCore.removeClass(panel, "collapsed");
    return setPanelWidth(panel, getSavedWidth());
  }
}

function effectiveCollapsed(panel) {
  if (shouldForceExpandedDesktop(panel) || !isNarrowViewport() && lhspDesktopExpandedContentOpen(panel)) {
    return false;
  } else {
    return getSavedCollapsed();
  }
}

function applyGameHubPanelHidden(panel, hidden) {
  if (hidden) {
    DomEl$GameDataCore.addClass(panel, "game-hub-panel-hidden");
    return SidebarPadSyncHook$GameDataCore.syncAppSidebarPad();
  } else {
    DomEl$GameDataCore.removeClass(panel, "game-hub-panel-hidden");
    return applyCollapsedState(panel, effectiveCollapsed(panel));
  }
}

function toggleGameHubGamesPanel() {
  var panel = document.getElementById("games-list-panel");
  if (panel == null) {
    return ;
  }
  if (!isGameHubPath(window.location.pathname)) {
    return ;
  }
  var nextHidden = DomEl$GameDataCore.hasClass(panel, "game-hub-panel-hidden");
  setGameHubPanelHidden(nextHidden);
  applyGameHubPanelHidden(panel, nextHidden);
  if (!nextHidden) {
    setSavedCollapsed(false);
    return applyCollapsedState(panel, false);
  }
  
}

var gameHubNavToggleBound = {
  contents: false
};

function bindGameHubNavToggle() {
  if (gameHubNavToggleBound.contents) {
    return ;
  }
  gameHubNavToggleBound.contents = true;
  var handler = function ($$event) {
    var target = $$event.target;
    if (target == null) {
      return ;
    }
    var match = target.closest("[data-game-hub-nav-toggle]");
    if (match == null) {
      return ;
    }
    if (!isGameHubPath(window.location.pathname)) {
      return ;
    }
    var match$1 = document.getElementById("games-list-panel");
    if (!(match$1 == null)) {
      $$event.preventDefault();
      $$event.stopPropagation();
      return toggleGameHubGamesPanel();
    }
    
  };
  document.addEventListener("click", handler, true);
}

function maybeExpandGamesListForGameHub(_pathname) {
  if (isNarrowViewport()) {
    return ;
  }
  setSavedCollapsed(false);
  setGameHubPanelHidden(false);
  var panel = document.getElementById("games-list-panel");
  if (!(panel == null)) {
    applyGameHubPanelHidden(panel, false);
    return applyCollapsedState(panel, false);
  }
  
}

function maybeCollapseGamesListForWorkspaceChange(previousPathname, nextPathname) {
  if (isNarrowViewport()) {
    return ;
  }
  var match = workspaceLhspActionForPathChange(previousPathname, nextPathname);
  switch (match) {
    case "collapse" :
        setSavedCollapsed(true);
        var panel = document.getElementById("games-list-panel");
        if (!(panel == null)) {
          return applyCollapsedState(panel, true);
        } else {
          return ;
        }
    case "expand-game-hub" :
        return maybeExpandGamesListForGameHub(nextPathname);
    default:
      return ;
  }
}

function mounted() {
  var self = this ;
  var panel = self.el;
  if (isGameHubPath(window.location.pathname) && getGameHubPanelHidden()) {
    applyGameHubPanelHidden(panel, true);
  } else {
    applyCollapsedState(panel, effectiveCollapsed(panel));
  }
  bindGameHubNavToggle();
  panel._gdcIsResizing = false;
  var clickHandler = function ($$event) {
    if (shouldForceExpandedDesktop(panel)) {
      return ;
    }
    var target = $$event.target;
    if (target == null) {
      return ;
    }
    var match = target.closest("[data-games-list-toggle]");
    if (match == null) {
      return ;
    }
    if (!isNarrowViewport() && lhspDesktopExpandedContentOpen(panel)) {
      return ;
    }
    if (isGameHubPath(window.location.pathname)) {
      var nextHidden = DomEl$GameDataCore.hasClass(panel, "game-hub-panel-hidden");
      setGameHubPanelHidden(nextHidden);
      applyGameHubPanelHidden(panel, nextHidden);
      if (!nextHidden) {
        setSavedCollapsed(false);
        return applyCollapsedState(panel, false);
      } else {
        return ;
      }
    }
    var nowCollapsed = !DomEl$GameDataCore.hasClass(panel, "collapsed");
    setSavedCollapsed(nowCollapsed);
    applyCollapsedState(panel, nowCollapsed);
  };
  panel._gdcClickHandler = clickHandler;
  panel.addEventListener("click", clickHandler);
  var mouseMove = function ($$event) {
    if (isResizing(panel) || DomEl$GameDataCore.hasClass(panel, "collapsed")) {
      return ;
    }
    var rect = panel.getBoundingClientRect();
    var near = isNearGamesListResizeEdge($$event.clientX, rect.right, undefined);
    panel.style.cursor = near ? "ew-resize" : "";
  };
  panel._gdcMouseMove = mouseMove;
  var mouseDown = function ($$event) {
    if (DomEl$GameDataCore.hasClass(panel, "collapsed")) {
      return ;
    }
    var rect = panel.getBoundingClientRect();
    if (!isNearGamesListResizeEdge($$event.clientX, rect.right, undefined)) {
      return ;
    }
    panel._gdcIsResizing = true;
    var startX = $$event.clientX;
    var startWidth = panel.offsetWidth;
    var body = document.body.style;
    body.cursor = "ew-resize";
    body.userSelect = "none";
    $$event.preventDefault();
    var docMouseMove = function (moveEvent) {
      if (!isResizing(panel)) {
        return ;
      }
      var delta = moveEvent.clientX - startX;
      var newWidth = clampGamesListWidth(startWidth + (delta | 0) | 0);
      setPanelWidth(panel, newWidth);
      setSavedWidth(newWidth);
    };
    panel._gdcDocMouseMove = docMouseMove;
    var docMouseUp = function (_event) {
      if (isResizing(panel)) {
        panel._gdcIsResizing = false;
        var body = document.body.style;
        body.cursor = "";
        body.userSelect = "";
        panel.style.cursor = "";
      }
      var handler = panel._gdcDocMouseMove;
      if (handler !== undefined) {
        document.removeEventListener("mousemove", handler, false);
      }
      var handler$1 = panel._gdcDocMouseUp;
      if (handler$1 !== undefined) {
        document.removeEventListener("mouseup", handler$1, false);
      }
      panel._gdcDocMouseMove = undefined;
      panel._gdcDocMouseUp = undefined;
    };
    panel._gdcDocMouseUp = docMouseUp;
    var handler = panel._gdcDocMouseMove;
    if (handler !== undefined) {
      document.addEventListener("mousemove", handler, false);
    }
    var handler$1 = panel._gdcDocMouseUp;
    if (handler$1 !== undefined) {
      document.addEventListener("mouseup", handler$1, false);
      return ;
    }
    
  };
  panel._gdcMouseDown = mouseDown;
  panel.addEventListener("mousemove", mouseMove);
  panel.addEventListener("mousedown", mouseDown);
  var onResizePad = function (param) {
    if (!isResizing(panel)) {
      return SidebarPadSyncHook$GameDataCore.syncAppSidebarPad();
    }
    
  };
  panel._gdcOnResizePad = onResizePad;
  window.addEventListener("resize", onResizePad);
  window.addEventListener("gdc:main-nav-rail-resize", onResizePad);
  SidebarPadSyncHook$GameDataCore.syncAppSidebarPad();
}

function updated() {
  var self = this ;
  var panel = self.el;
  if (isResizing(panel)) {
    return ;
  } else if (isGameHubPath(window.location.pathname) && getGameHubPanelHidden()) {
    return applyGameHubPanelHidden(panel, true);
  } else {
    DomEl$GameDataCore.removeClass(panel, "game-hub-panel-hidden");
    return applyCollapsedState(panel, effectiveCollapsed(panel));
  }
}

function destroyed() {
  var self = this ;
  var panel = self.el;
  panel._gdcIsResizing = false;
  var handler = panel._gdcOnResizePad;
  if (handler !== undefined) {
    window.removeEventListener("resize", handler);
    window.removeEventListener("gdc:main-nav-rail-resize", handler);
  }
  panel._gdcOnResizePad = undefined;
  var handler$1 = panel._gdcClickHandler;
  if (handler$1 !== undefined) {
    panel.removeEventListener("click", handler$1);
  }
  panel._gdcClickHandler = undefined;
  var handler$2 = panel._gdcMouseMove;
  if (handler$2 !== undefined) {
    panel.removeEventListener("mousemove", handler$2);
  }
  panel._gdcMouseMove = undefined;
  var handler$3 = panel._gdcMouseDown;
  if (handler$3 !== undefined) {
    panel.removeEventListener("mousedown", handler$3);
  }
  panel._gdcMouseDown = undefined;
  var handler$4 = panel._gdcDocMouseMove;
  if (handler$4 !== undefined) {
    document.removeEventListener("mousemove", handler$4, false);
  }
  panel._gdcDocMouseMove = undefined;
  var handler$5 = panel._gdcDocMouseUp;
  if (handler$5 !== undefined) {
    document.removeEventListener("mouseup", handler$5, false);
  }
  panel._gdcDocMouseUp = undefined;
}

var gamesListCollapse = {
  mounted: mounted,
  updated: updated,
  destroyed: destroyed
};

var syncAppSidebarPad = SidebarPadSyncHook$GameDataCore.syncAppSidebarPad;

var appShellMdMinPx = 1480;

var gamesListDefaultWidth = 320;

var gamesListMinWidth = 220;

var gamesListMaxWidth = 600;

var gamesListCollapsedWidth = 48;

var resizeZone = 8;

export {
  syncAppSidebarPad ,
  appShellMdMinPx ,
  appShellNarrowMaxPx ,
  widthStorageKey ,
  collapsedStorageKey ,
  gameHubPanelHiddenKey ,
  gamesListDefaultWidth ,
  gamesListMinWidth ,
  gamesListMaxWidth ,
  gamesListCollapsedWidth ,
  resizeZone ,
  isResizing ,
  isGameHubPath ,
  lhspWorkspaceKeyFromPath ,
  workspaceLhspActionForPathChange ,
  clampGamesListWidth ,
  isNearGamesListResizeEdge ,
  isNarrowViewport ,
  getSavedWidth ,
  setSavedWidth ,
  getSavedCollapsed ,
  setSavedCollapsed ,
  getGameHubPanelHidden ,
  setGameHubPanelHidden ,
  fixedExpandedDesktop ,
  shouldForceExpandedDesktop ,
  lhspDesktopExpandedContentOpen ,
  setPanelWidth ,
  applyCollapsedState ,
  effectiveCollapsed ,
  applyGameHubPanelHidden ,
  toggleGameHubGamesPanel ,
  gameHubNavToggleBound ,
  bindGameHubNavToggle ,
  maybeExpandGamesListForGameHub ,
  maybeCollapseGamesListForWorkspaceChange ,
  mounted ,
  updated ,
  destroyed ,
  gamesListCollapse ,
}
/* mounted Not a pure module */
